import validate from "validate.js";
import { KEY_ENTER } from "../lib";

export function validateForm(data: any, constraints: any) {
    const result: Record<string, Array<string>> = validate(data, constraints);
    if (!result) {
        return [];
    }

    const errors: Array<string> = [];

    for (const list of Object.values(result)) {
        for (const value of list) {
            const e = value.split(" ");
            if (e.length > 0) {
                errors.push(e[e.length - 1]);
            }
        }
    }

    return errors;
}

export function submitIfEnter(
    evt: React.KeyboardEvent<HTMLElement>,
    submitFn: () => void
) {
    if (evt.key === KEY_ENTER) {
        submitFn();
    }
}
